/* eslint-disable no-restricted-syntax */
import Navigation from 'components/navigation'
import Wrapper from 'common/wrapper'
import Footer from 'common/footer'
import OpenGraph from 'common/open-graph'
import PrivacyGrid from 'components/privacity/privacy'

function Privacy() {
  return (
    <>
      <OpenGraph
        title="Politica de privacidad | LeonidasEsteban"
        keyword="privacidad"
      />
      <Navigation position="sticky" />
      <Wrapper maxWidth={600}>
        <PrivacyGrid />
      </Wrapper>
      <Footer />
    </>
  )
}

export default Privacy
